export default __webpack_public_path__ + "static/media/1852.1519173b.png";